import * as React from "react";
import { cn } from "@/lib/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      className={cn(
        "flex h-11 w-full rounded-nav border border-waves-line bg-white px-4 text-[15px] font-medium text-waves-ink transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:font-normal placeholder:text-waves-muted focus-visible:border-waves-zee focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-waves-zee/25 disabled:cursor-not-allowed disabled:bg-waves-subtle disabled:opacity-70",
        className
      )}
      ref={ref}
      {...props}
    />
  )
);
Input.displayName = "Input";

export { Input };
